export default {
      id: "icon--info-small-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--info-small-usage",
      toString: function () {
        return this.url;
      }
    }